// PL
export const hotelRatesManager = {
  perNight: "/ noc",
  roomFallback: "Pokój #{id}",

  header: {
    eyebrow: "Taryfy główne",
    title: "Taryfy hotelowe",
    subtitle:
      "Twórz taryfy bazowe i stosuj je do jednego lub wielu pokoi. Taryfy pochodne synchronizują się z channel managerem.",
    newMain: "Nowa taryfa główna",
  },
  states: {
    loading: "Wczytywanie taryf…",
    emptyTitle: "Nie ma jeszcze taryf",
    emptySubtitle:
      "Utwórz pierwszą taryfę główną, aby zacząć zarządzać cenami i synchronizować je z channel managerem.",
    createFirst: "Utwórz pierwszą taryfę",
  },
  card: {
    mainBadge: "Główna",
    occupancy: "Obł. {count}",
    minStay: "Min. {count} noc | Min. {count} noce | Min. {count} nocy",
    editRate: "Edytuj taryfę",
    deleteRate: "Usuń taryfę",
    rooms: "Pokoje",
    syncedTooltip: "Zsynchronizowane z channel managerem",
    removeSyncedTooltip: "Usuń (uwaga: channel manager)",
    removeRoomTooltip: "Usuń z tego pokoju",
    add: "Dodaj",
    selectRoom: "Wybierz pokój",
    derivedBadge: "Pochodna",
    derivedFrom: "od: {name}",
    sameNameHint: "Istnieje inna taryfa „{name}” o innej cenie lub innych warunkach. Każdą kartę edytuje się osobno.",
    editDerived: "Edytuj pochodną",
    deleteDerived: "Usuń pochodną",
  },
  derived: {
    toggle: "Taryfy pochodne",
    empty:
      "Nie ma jeszcze taryf pochodnych. Utwórz jedną dla Booking.com, Airbnb lub konkretnych OTA.",
    newDerived: "Nowa taryfa pochodna",
  },
  common: {
    allRooms: "wszystkie pokoje",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    creating: "Tworzenie…",
    saveChanges: "Zapisz zmiany",
    removeAll: "Wyczyść wszystko",
  },
  mainModal: {
    editTitle: "Edytuj taryfę główną",
    newTitle: "Nowa taryfa główna",
    nameLabel: "Nazwa",
    namePlaceholder: "Np. Taryfa standardowa, Weekend…",
    priceLabel: "Cena za noc",
    occupancyLabel: "Obłożenie",
    minStayLabel: "Minimalny pobyt (noce)",
    maxStayLabel: "Maksymalny pobyt (noce)",
    validityLabel: "Okres obowiązywania",
    permanent: "Bezterminowo",
    dateRange: "Zakres dat",
    from: "Od",
    to: "Do",
    descriptionLabel: "Opis (opcjonalnie)",
    descriptionPlaceholder: "Notatki wewnętrzne o tej taryfie…",
    searchPlaceholder: "Szukaj pokoju…",
    selectAllShort: "Wszystkie",
    noResults: 'Brak wyników dla "{query}"',
    noRoomsAvailable: "Brak dostępnych pokoi",
    editInfo: "Zmiany zostaną zastosowane do: {rooms} w tej karcie.",
    createRate: "Utwórz taryfę",
  },
  derivedModal: {
    editTitle: "Edytuj taryfę pochodną",
    newTitle: "Nowa taryfa pochodna",
    subtitle: "Pochodna od: {name} · {price}",
    nameLabel: "Nazwa taryfy pochodnej",
    namePlaceholder: "Np. Booking.com, Airbnb, Bez śniadania…",
    nameHint: "Ta nazwa identyfikuje taryfę w channel managerze.",
    adjustTypeLabel: "Rodzaj korekty",
    percentage: "Procent",
    fixedAmount: "Kwota stała",
    adjustValueLabel: "Wartość korekty",
    adjustValueHint: "(wartość ujemna = zniżka)",
    resultPriceLabel: "Cena wynikowa",
    baseLabel: "Baza",
    applyToRooms: "Zastosuj do pokoi",
    onlyMainRooms: "Wyświetlane są tylko pokoje, które mają taryfę główną.",
    noRoomsWithMain: "Taryfa główna nie jest jeszcze zastosowana w żadnym pokoju.",
    selectAll: "Zaznacz wszystko",
    editInfo:
      "Edycja zaktualizuje korektę dla: {rooms}, które mają tę taryfę pochodną.",
    createDerived: "Utwórz pochodną",
  },
  removeModal: {
    title: "Usuń z pokoju",
    syncWarnTitle: "Ta taryfa jest zsynchronizowana z channel managerem",
    syncWarnBody:
      "Usunięcie może {break} taryf w Channex dla tego pokoju. Sprawdź channel manager przed kontynuowaniem.",
    syncWarnBreak: "przerwać synchronizację",
    confirmText: "Ta operacja usunie z pokoju {room} taryfę: {rate}.",
    roomLabel: "Pokój",
    rateLabel: "Taryfa",
    statusLabel: "Status",
    syncedWithChannex: "Zsynchronizowane z Channex",
    removing: "Usuwanie…",
    removeAnyway: "Rozumiem, usuń mimo to",
    confirm: "Usuń z pokoju",
  },
  deleteModal: {
    title: "Usuń taryfę",
    warnTitle: "Tej operacji nie można cofnąć",
    warnBody: "Taryfa {rate} zostanie usunięta z: {rooms}.",
    roomsCount: "{count} pokoju | {count} pokoi | {count} pokoi",
    syncedWarn:
      "Niektóre pokoje są zsynchronizowane z Channex. Może to wpłynąć na synchronizację taryf.",
    confirmLabel: "Wpisz {name}, aby potwierdzić",
    deleting: "Usuwanie…",
    confirm: "Usuń trwale",
  },
  toasts: {
    loadError: "Błąd podczas wczytywania taryf hotelowych",
    mainCreated: "Taryfa utworzona w {count} pokoju | Taryfa utworzona w {count} pokojach | Taryfa utworzona w {count} pokojach",
    createdPartial: "Utworzono: {ok}, nieudane: {fail}",
    mainCreateFailAll: "Nie udało się utworzyć taryfy w żadnym pokoju",
    mainUpdated: "Taryfa zaktualizowana",
    updatedPartial: "Zaktualizowano: {ok}, nieudane: {fail}",
    mainUpdateFail: "Nie udało się zaktualizować taryfy",
    derivedCreated:
      "Taryfa pochodna utworzona w {count} pokoju | Taryfa pochodna utworzona w {count} pokojach | Taryfa pochodna utworzona w {count} pokojach",
    derivedCreateFail: "Nie udało się utworzyć taryfy pochodnej",
    derivedUpdated: "Taryfa pochodna zaktualizowana",
    derivedUpdateFail: "Nie udało się zaktualizować taryfy pochodnej",
    roomAddedMain: "Taryfa dodana do: {room}",
    addRateError: "Błąd podczas dodawania taryfy",
    noMainRate: "Ten pokój nie ma taryfy głównej. Najpierw ją dodaj.",
    roomAddedDerived: "Taryfa pochodna dodana do: {room}",
    addDerivedError: "Błąd podczas dodawania taryfy pochodnej",
    rateRemoved: "Taryfa usunięta z: {room}",
    removeError: "Błąd podczas usuwania taryfy",
    rateDeleted: "Taryfa usunięta",
    deletedPartial: "Usunięto: {ok}, nieudane: {fail}",
    deleteError: "Błąd podczas usuwania",
  },
  errors: {
    invalidRange: "Wybierz prawidłowy zakres dat",
    startAfterEnd: "Data początkowa nie może być późniejsza niż data końcowa",
    minStayRange: "Minimalny pobyt: {minStay} nocy, a zakres obejmuje: {nights}",
  },
};
